import { Coquanbanhanh } from './coquanbanhanh';
import { Linhvuc } from './linhvuc';
import { Loaivanban } from './loaivanban';
import { Nguoiky } from './nguoiky';
import { ThongtinvanbanFiledinhkem } from './thongtinvanbanFiledinhkem';
import { Donvi } from '../quanlythongtin/donvi';

export class Thongtinvanban {
    id : number;
    stt : number;
    sovanban : string;
    kyhieu : string;
    ngaybanhanh : Date;
    dmnguoiky : Nguoiky;
    nguoikyid : number;
    trichyeu : string;
    trichyeurutgon: string;
    dmcoquanbanhanh : Coquanbanhanh;
    coquanbanhanhid : number;
    dmloaivanban : Loaivanban;
    loaivanbanid : number;
    dmlinhvuc : Linhvuc;    
    linhvucid : number;
    trangthai : number;
    ngayhethieuluc : Date;
    ghichu:string;
    nguoitao:string;
    ngaytao : string;
    loai:number;
    taidonvi : number;
    tendv : string;
    dmdonvi: Donvi;
    donviid : number;
    capcoquan : number;
    
    isactive: number;
    createddate: Date;
    createdbyuserid: number;
    modifiedbyuserid: number;
    modifieddate: Date; 

    soVaKyHieu : string;
    filedinhkems: ThongtinvanbanFiledinhkem[];
    nguoiky:string;
}